// extracted by mini-css-extract-plugin
export default {"root":"AdditionalSettingsForm_root__MO3g1","sellPlaceGroup":"AdditionalSettingsForm_sellPlaceGroup__+A2Fr","placeHolderShimmer":"AdditionalSettingsForm_placeHolderShimmer__ChsH6"};